import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatDateShort } from "utils/dateUtils";
import { getExemptions, selectInput, selectState } from "../input.slice";
import { resourceMaintenanceTypeDictionary } from "utils/translationDictionary";
import classes from "../styles/BottomSection.module.scss";
import InfoTooltip from "components/Popup/InfoTooltip";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

const BottomSection = () => {
  const dispatch = useAppDispatch();

  const input = useSelector(selectInput);
  const { outputListItems, inputsLoading, exemptionsLoading } =
    useSelector(selectState);

  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    if (input) {
      dispatch(getExemptions({ inputId: input.inputId }))
        .then((result) => {
          let resultExemptions = result.payload;
          if (Array.isArray(resultExemptions)) {
            let totals = 0;
            resultExemptions.forEach((exe) => {
              totals += exe.quantityAmount;
            });
            setTotalQuantity(totals);
          }
          return resultExemptions;
        });
    }
  }, [dispatch, input?.inputId]);

  return (
    <section className={classes.bottomSection}>
      {(inputsLoading || exemptionsLoading) && <Loader />}
      <div className="consumables-table-wrapper">
        <div className="left-side">
          <div className="g-grid">
            <div className="row bottomTable header">
              <div><span>br. otpr-rač</span></div>
              <div><span>za koji resurs</span></div>
              <div><span>namena</span></div>
              <div><span>količina iz.</span></div>
              <div><span>cena izdatog</span></div>
              <div><span>datum izlaza</span></div>
              <div>
                <span>napomena</span>
                <span>
                  <select></select>
                </span>
              </div>
            </div>
          </div>
          <div className={`scroll-content bottom-content ${classes.table}`}>
            {outputListItems.length > 0 &&
              outputListItems.map((listItem, index) =>
                <div className="g-grid" key={listItem.outputItemId}>
                  <div className="row row_content bottomTable">
                    <div className="col center">
                      <span className="bg-item light center">
                        {input && input.billOfLandingId}
                      </span>
                    </div>
                    <div className="col strong left">
                      <div className="bg-item overflowMinWidth upper">
                        <InfoTooltip tooltip={listItem.resource.nameWithIdentifier}
                          classesProp="bg-text-overflow">
                          {listItem.resource.nameWithIdentifier}
                        </InfoTooltip>
                      </div>
                    </div>
                    <div className="col center">
                      <span className="bg-item light right">
                        {resourceMaintenanceTypeDictionary[listItem.resourceMaintenanceType]}
                      </span>
                    </div>
                    <div className="col right">
                      <span className="bg-item right">
                        {listItem.quantityAmount}
                      </span>
                    </div>
                    <div className="col right">
                      <div className="bg-item overflowMinWidth right">
                        <InfoTooltip
                          tooltip={FormatNumberWithUnitOrNull(listItem.totalPrice, 'rsd') ?? undefined}
                          classesProp="bg-text-overflow">
                          {FormatNumberWithUnitOrNull(listItem.totalPrice, 'rsd')}
                        </InfoTooltip>
                      </div>
                    </div>
                    <div className="col center">
                      <span className="bg-item light center">
                        {FormatDateShort(listItem.date)}
                      </span>
                    </div>
                    <div className="col left">
                      <span className="bg-item">{listItem.note}</span>
                    </div>
                  </div>
                </div>
              )}
          </div>

          <div className="g-grid">
            <div className="row bottomTable footerBottomTable">
              <div></div>
              <div></div>
              <div></div>
              <div className="col strong right">
                <span className="reed text-small">{totalQuantity}</span>
              </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>

        <div className="right-side">
          <div><select></select></div>
          <div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomSection;
